<google-map [center]="{ lng: center.x, lat: center.y }" height="600px" [options]="options" width="1024px">
  <ng-container *ngFor="let ecopoint of ecopoints">
    <map-marker #marker="mapMarker"
      [options]="icon" [position]="convert(ecopoint.center)" (mapMouseover)="onEcopoint(marker, ecopoint)">
    </map-marker>
    <map-info-window><a href="/containers/ecopoint/{{ecopointId}}">{{content}}</a></map-info-window>
  </ng-container>
</google-map >
